import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  &.clickable {
    cursor: pointer;
  }

  &.clickable:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }

  .date-box {
    flex-shrink: 0;
    width: 64px;
    height: 72px;
    background: #f3f3f3;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  .date-box .day {
    font-size: 1.6rem;
    font-weight: 600;
    color: #000;
  }

  .date-box .month {
    font-size: 0.8rem;
    font-weight: 600;
    color: #000;
    margin-top: 4px;
  }

  .content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .content-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .titles {
    min-width: 0;
  }

  .titles .title {
    font-size: 1rem;
    font-weight: 700;
    color: #000;
    margin-bottom: 2px;
  }

  .titles .subtitle {
    font-size: 0.85rem;
    font-weight: 400;
    color: #6c757d;
  }

  .badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .badge-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #28a745;
    color: #fff;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
  }

  .badge-pill .material-icons {
    font-size: 12px;
  }

  .action {
    flex-shrink: 0;
  }

  @media (max-width: 576px) {
    gap: 12px;

    .content-top {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }
`;
